import { useEffect, useState } from "react";

import {
    Box,
    Container,
    Typography,
    Button,
    Paper,
    Stack,
    Chip,
    IconButton,
    TextField,
    MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Divider,
    CircularProgress,
} from "@mui/material";

import AddRoundedIcon from "@mui/icons-material/AddRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import ImageRoundedIcon from "@mui/icons-material/ImageRounded";
import { formatearFecha } from "../../utils/FormatoFecha";

import { useComunidad } from "../../hooks/UseComunidad";

import StatusModal from "../../utils/StatusModal";


export const Comunidad = () => {
    const backendURL = process.env.REACT_APP_BACKEND_URL;
    const {
        comunidades,
        loading,
        error,

        cargarComunidades,

        guardarComunidad,
        editarComunidad,
        borrarComunidad,
    } = useComunidad();

     useEffect(() => {
        cargarComunidades();
    }, []);
    // =========================================
    // ESTADOS
    // =========================================

    const [open, setOpen] = useState(false);

    const [modo, setModo] =
        useState("crear");

    const [editando, setEditando] =
        useState(null);


    const [filtroTipo, setFiltroTipo] =
        useState("todos");

    const [filtroDestacado, setFiltroDestacado] =
        useState("todos");


    const [formulario, setFormulario] =
        useState({
            destacado: false,
            tipo: "informativo",
            titulo: "",
            fecha: "",
            pie_portada: "",
            contenido: "",
            imagen: null,
        });


    const [preview, setPreview] =
        useState(null);


    const [status, setStatus] =
        useState({
            open: false,
            type: "success",
            message: "",
        });


    // =========================================
    // CARGAR
    // =========================================

    useEffect(() => {

        cargarComunidades();

    }, []);


    // =========================================
    // STATUS
    // =========================================

    const mostrarStatus = (
        type,
        message
    ) => {

        setStatus({
            open: true,
            type,
            message,
        });

    };

    const cerrarStatus = () => {

         setStatus((prev) => ({
            ...prev,
            open: false,
        }));

    };

    // =========================================
    // CAMBIAR INPUT
    // =========================================

    const handleChange = (event) => {

        const {
            name,
            value,
            files,
        } = event.target;


        if (name === "imagen") {

            const file = files?.[0];

            setFormulario((prev) => ({
                ...prev,
                imagen: file,
            }));


            if (file) {

                setPreview(
                    URL.createObjectURL(file)
                );

            }

            return;
        }


        setFormulario((prev) => ({
            ...prev,
            [name]: value,
        }));

    };


    // =========================================
    // NUEVO
    // =========================================

    const handleNuevo = () => {

        setModo("crear");

        setEditando(null);

        setFormulario({
            destacado: false,
            tipo: "informativo",
            titulo: "",
            fecha: "",
            pie_portada: "",
            contenido: "",
            imagen: null,
        });

        setPreview(null);

        setOpen(true);

    };


    // =========================================
    // EDITAR
    // =========================================

   const handleEditar = (item) => {

    setModo("editar");
    setEditando(item);

    setFormulario({
        destacado: Boolean(item.destacado),
        tipo: item.tipo || "informativo",
        titulo: item.titulo || "",
        fecha: item.fecha || "",
        pie_portada: item.pie_portada || "",
        contenido: item.contenido || "",
        imagen: null,
    });

    setPreview(
        item.imagen_url ||
        item.imagen ||
        null
    );

    setOpen(true);
};

    // =========================================
    // GUARDAR
    // =========================================

    const handleGuardar = async () => {

        try {

            const formData =
                new FormData();


            formData.append(
            "destacado",
            formulario.destacado ? "1" : "0"
        )

            formData.append(
                "tipo",
                formulario.tipo
            );

            formData.append(
                "titulo",
                formulario.titulo
            );

            formData.append(
                "fecha",
                formulario.fecha
            );

            formData.append(
                "pie_portada",
                formulario.pie_portada
            );

            formData.append(
                "contenido",
                formulario.contenido
            );


            if (formulario.imagen) {

                formData.append(
                    "imagen",
                    formulario.imagen
                );

            }


            if (modo === "crear") {

                await guardarComunidad(
                    formData
                );

                mostrarStatus(
                    "success",
                    "Publicación creada correctamente."
                );

                 setTimeout(() => {
            cerrarStatus();

        }, 1800);

            } else {

                await editarComunidad(
                    editando.id,
                    formData
                );

                mostrarStatus(
                    "success",
                    "Publicación actualizada correctamente."
                );
                 setTimeout(() => {
            cerrarStatus();

        }, 1800);

            }


            setOpen(false);

        } catch (error) {

            console.error(error);

            mostrarStatus(
                "error",
                error?.response?.data?.message ||
                "No se pudo guardar la publicación."
            );

             setTimeout(() => {
            cerrarStatus();

        }, 1800);

        }

    };


    // =========================================
    // ELIMINAR
    // =========================================

    const handleEliminar = async (item) => {

        const confirmar =
            window.confirm(
                `¿Deseas eliminar "${item.titulo}"?`
            );


        if (!confirmar) {
            return;
        }


        try {

            await borrarComunidad(
                item.id
            );

            mostrarStatus(
                "success",
                "Publicación eliminada correctamente."
            );
             setTimeout(() => {
            cerrarStatus();

        }, 1800);

        } catch (error) {

            mostrarStatus(
                "error",
                "No se pudo eliminar la publicación."
            );
             setTimeout(() => {
            cerrarStatus();

        }, 1800);

        }

    };


    // =========================================
    // FILTRADO
    // =========================================

    const comunidadesFiltradas =
        Array.isArray(comunidades)
            ? comunidades.filter((item) => {

                const tipoCorrecto =
                    filtroTipo === "todos" ||
                    item.tipo === filtroTipo;


                const destacadoCorrecto =
                    filtroDestacado === "todos" ||
                    item.destacado === filtroDestacado;


                return (
                    tipoCorrecto &&
                    destacadoCorrecto
                );

            })
            : [];


    // =========================================
    // COLOR TIPO
    // =========================================

    const getTipoColor = (tipo) => {

        switch (tipo) {

            case "importante":
                return "#C1121F";

            case "recordatorio":
                return "#D97706";

            case "informativo":
                return "#3157A4";

            default:
                return "#64748B";
        }

    };


    return (

        <Container
            maxWidth="xl"
            sx={{
                py: 4,
            }}
        >

            {/* =================================
                HEADER
            ================================= */}

            <Box
                sx={{
                    mb: 4,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: {
                        xs: "flex-start",
                        md: "center",
                    },
                    flexDirection: {
                        xs: "column",
                        md: "row",
                    },
                    gap: 2,
                }}
            >

                <Box>

                    <Typography
                        sx={{
                            fontSize: "1.8rem",
                            fontWeight: 800,
                            color: "#1B2A41",
                        }}
                    >
                        Comunidad
                    </Typography>

                    <Typography
                        sx={{
                            color: "#64748B",
                            mt: .5,
                        }}
                    >
                        Administra las publicaciones y
                        novedades de la comunidad escolar.
                    </Typography>

                </Box>


                <Button
                    variant="contained"
                    startIcon={
                        <AddRoundedIcon />
                    }
                    onClick={handleNuevo}
                    sx={{
                        backgroundColor: "#3157A4",
                        borderRadius: "12px",
                        px: 2.5,
                        py: 1.2,
                        textTransform: "none",
                        fontWeight: 700,

                        "&:hover": {
                            backgroundColor: "#24468A",
                        },
                    }}
                >
                    Nueva publicación
                </Button>

            </Box>


            {/* =================================
                FILTROS
            ================================= */}

            <Paper
                sx={{
                    p: 2,
                    mb: 3,
                    borderRadius: "16px",
                    border: "1px solid #EEF1F5",
                    boxShadow: "none",
                }}
            >

                <Stack
                    direction={{
                        xs: "column",
                        sm: "row",
                    }}
                    spacing={2}
                >

                    <TextField
                        select
                        label="Tipo"
                        value={filtroTipo}
                        onChange={(e) =>
                            setFiltroTipo(
                                e.target.value
                            )
                        }
                        size="small"
                        sx={{
                            minWidth: 200,
                        }}
                    >

                        <MenuItem value="todos">
                            Todos
                        </MenuItem>

                        <MenuItem value="importante">
                            Importante
                        </MenuItem>

                        <MenuItem value="recordatorio">
                            Recordatorio
                        </MenuItem>

                        <MenuItem value="informativo">
                            Informativo
                        </MenuItem>

                    </TextField>


                    <TextField
    select
    fullWidth
    label="¿Destacado?"
    name="destacado"
    value={formulario.destacado ? "true" : "false"}
    onChange={(e) => {
        setFormulario((prev) => ({
            ...prev,
            destacado: e.target.value === "true",
        }));
    }}
>
    <MenuItem value="true">
        Sí
    </MenuItem>

    <MenuItem value="false">
        No
    </MenuItem>
</TextField>

                </Stack>

            </Paper>


            {/* =================================
                TABLA
            ================================= */}

            <Paper
                sx={{
                    borderRadius: "18px",
                    overflow: "hidden",
                    border: "1px solid #EEF1F5",
                    boxShadow: "0 5px 20px rgba(0,0,0,.04)",
                }}
            >

                {/* CABECERA */}

                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns:
                            "80px 2fr 150px 120px 140px",
                        alignItems: "center",
                        px: 3,
                        py: 2,
                        backgroundColor: "#F8FAFC",
                        borderBottom:
                            "1px solid #EEF1F5",
                    }}
                >

                    <Typography
                        fontWeight={700}
                        fontSize=".8rem"
                    >
                        Imagen
                    </Typography>

                    <Typography
                        fontWeight={700}
                        fontSize=".8rem"
                    >
                        Publicación
                    </Typography>

                    <Typography
                        fontWeight={700}
                        fontSize=".8rem"
                    >
                        Tipo
                    </Typography>

                    <Typography
                        fontWeight={700}
                        fontSize=".8rem"
                    >
                        Destacado
                    </Typography>

                    <Typography
                        fontWeight={700}
                        fontSize=".8rem"
                        textAlign="center"
                    >
                        Acciones
                    </Typography>

                </Box>


                {/* LOADING */}

                {loading && (
                    <Box
                        sx={{
                            py: 8,
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <CircularProgress
                            size={30}
                            sx={{
                                color: "#3157A4",
                            }}
                        />
                    </Box>
                )}


                {/* FILAS */}

                {!loading &&
                    comunidadesFiltradas.map(
                        (item) => (

                            <Box
                                key={item.id}
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns:
                                        "80px 2fr 150px 120px 140px",
                                    alignItems: "center",
                                    px: 3,
                                    py: 1.8,
                                    borderBottom:
                                        "1px solid #EEF1F5",

                                    "&:hover": {
                                        backgroundColor:
                                            "#FAFBFD",
                                    },
                                }}
                            >

                                {/* IMAGEN */}

                                <Box
                                    sx={{
                                        width: 55,
                                        height: 45,
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                        backgroundColor:
                                            "#F1F5F9",
                                        display: "flex",
                                        alignItems:
                                            "center",
                                        justifyContent:
                                            "center",
                                    }}
                                >

                                    {item.imagen_url || item.imagen ? (
    <Box
        component="img"
        src={`${backendURL}/${item.imagen_url || item.imagen}`}
        alt={item.titulo}
        sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
        }}
    />
) : (
    <ImageRoundedIcon
        sx={{
            color: "#94A3B8",
        }}
    />
)}

                                </Box>


                                {/* PUBLICACIÓN */}

                                <Box>

                                    <Typography
                                        sx={{
                                            fontWeight: 700,
                                            color: "#334155",
                                        }}
                                    >
                                        {item.titulo}
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontSize: ".78rem",
                                            color: "#94A3B8",
                                            mt: .3,
                                        }}
                                    >
                                        {formatearFecha(item.fecha)}
                                    </Typography>

                                </Box>


                                {/* TIPO */}

                                <Box>

                                    <Chip
                                        label={
                                            item.tipo
                                        }
                                        size="small"
                                        sx={{
                                            textTransform:
                                                "capitalize",
                                            fontWeight: 700,
                                            color:
                                                getTipoColor(
                                                    item.tipo
                                                ),
                                            backgroundColor:
                                                `${getTipoColor(
                                                    item.tipo
                                                )}15`,
                                        }}
                                    />

                                </Box>


                                {/* DESTACADO */}

                                <Box>

                                    <Chip
    label={
        item.destacado
            ? "Sí"
            : "No"
    }
    size="small"
    sx={{
        fontWeight: 700,

        color: item.destacado
            ? "#15803D"
            : "#64748B",

        backgroundColor: item.destacado
            ? "#DCFCE7"
            : "#F1F5F9",
    }}
/>
                                </Box>


                                {/* ACCIONES */}

                                <Stack
                                    direction="row"
                                    justifyContent="center"
                                >

                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            handleEditar(
                                                item
                                            )
                                        }
                                        sx={{
                                            color:
                                                "#64748B",
                                        }}
                                    >
                                        <EditRoundedIcon
                                            fontSize="small"
                                        />
                                    </IconButton>


                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            handleEliminar(
                                                item
                                            )
                                        }
                                        sx={{
                                            color:
                                                "#DC2626",
                                        }}
                                    >
                                        <DeleteOutlineRoundedIcon
                                            fontSize="small"
                                        />
                                    </IconButton>

                                </Stack>

                            </Box>

                        )
                    )}


                {/* SIN REGISTROS */}

                {!loading &&
                    comunidadesFiltradas.length ===
                        0 && (

                        <Box
                            sx={{
                                py: 8,
                                textAlign: "center",
                            }}
                        >

                            <Typography
                                fontWeight={700}
                                color="#475569"
                            >
                                No hay publicaciones
                            </Typography>

                            <Typography
                                fontSize=".85rem"
                                color="#94A3B8"
                            >
                                Crea una publicación
                                para comenzar.
                            </Typography>

                        </Box>

                    )}

            </Paper>


            {/* =================================
                MODAL CREAR / EDITAR
            ================================= */}

            <Dialog
                open={open}
                onClose={() =>
                    setOpen(false)
                }
                fullWidth
                maxWidth="md"
            >

                <DialogTitle
                    sx={{
                        fontWeight: 800,
                    }}
                >
                    {modo === "crear"
                        ? "Nueva publicación"
                        : "Editar publicación"}
                </DialogTitle>

                <Divider />

                <DialogContent>

                    <Stack spacing={2.5} sx={{ mt: 1 }}>

                        <Stack
                            direction={{
                                xs: "column",
                                sm: "row",
                            }}
                            spacing={2}
                        >

                            <TextField
                                select
                                fullWidth
                                label="Tipo"
                                name="tipo"
                                value={
                                    formulario.tipo
                                }
                                onChange={
                                    handleChange
                                }
                            >

                                <MenuItem value="importante">
                                    Importante
                                </MenuItem>

                                <MenuItem value="recordatorio">
                                    Recordatorio
                                </MenuItem>

                                <MenuItem value="informativo">
                                    Informativo
                                </MenuItem>

                            </TextField>


                            <TextField
    select
    fullWidth
    label="¿Destacado?"
    name="destacado"
    value={formulario.destacado ? "true" : "false"}
    onChange={(e) => {
        setFormulario((prev) => ({
            ...prev,
            destacado: e.target.value === "true",
        }));
    }}
>
    <MenuItem value="true">
        Sí
    </MenuItem>

    <MenuItem value="false">
        No
    </MenuItem>
</TextField>

                        </Stack>


                        <TextField
                            fullWidth
                            label="Título"
                            name="titulo"
                            value={
                                formulario.titulo
                            }
                            onChange={
                                handleChange
                            }
                        />


                        <TextField
                            fullWidth
                            type="date"
                            label="Fecha"
                            name="fecha"
                            value={
                                formulario.fecha
                            }
                            onChange={
                                handleChange
                            }
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />


                        <TextField
                            fullWidth
                            label="Pie de portada"
                            name="pie_portada"
                            value={
                                formulario.pie_portada
                            }
                            onChange={
                                handleChange
                            }
                            multiline
                            rows={2}
                        />


                        <TextField
                            fullWidth
                            label="Contenido"
                            name="contenido"
                            value={
                                formulario.contenido
                            }
                            onChange={
                                handleChange
                            }
                            multiline
                            rows={6}
                        />


                        {/* IMAGEN */}

                        <Box>

                            <Typography
                                fontWeight={700}
                                mb={1}
                            >
                                Imagen de portada
                            </Typography>


                            <Button
                                component="label"
                                variant="outlined"
                                startIcon={
                                    <ImageRoundedIcon />
                                }
                                sx={{
                                    textTransform:
                                        "none",
                                    borderRadius:
                                        "10px",
                                }}
                            >
                                Seleccionar imagen

                                <input
                                    hidden
                                    type="file"
                                    name="imagen"
                                    accept="image/*"
                                    onChange={
                                        handleChange
                                    }
                                />

                            </Button>


                            {preview && (

                                <Box
                                    component="img"
                                    src={preview}
                                    sx={{
                                        display:
                                            "block",
                                        mt: 2,
                                        width:
                                            "100%",
                                        maxHeight:
                                            220,
                                        objectFit:
                                            "cover",
                                        borderRadius:
                                            "12px",
                                    }}
                                />

                            )}

                        </Box>

                    </Stack>

                </DialogContent>


                <DialogActions
                    sx={{
                        px: 3,
                        pb: 2.5,
                    }}
                >

                    <Button
                        onClick={() =>
                            setOpen(false)
                        }
                        sx={{
                            textTransform:
                                "none",
                        }}
                    >
                        Cancelar
                    </Button>


                    <Button
                        variant="contained"
                        onClick={
                            handleGuardar
                        }
                        disabled={loading}
                        sx={{
                            backgroundColor:
                                "#3157A4",
                            textTransform:
                                "none",
                            borderRadius:
                                "10px",
                            px: 3,
                        }}
                    >
                        {loading
                            ? "Guardando..."
                            : "Guardar"}
                    </Button>

                </DialogActions>

            </Dialog>


            <StatusModal
                open={status.open}
                type={status.type}
                message={status.message}
                onClose={() =>
                    setStatus({
                        ...status,
                        open: false,
                    })
                }
            />

        </Container>

    );
};